import ServiceHeader from "../../ServiceComponents/ServiceHeader";


export default function AboutBGSection() {
    return (
        <>
            <ServiceHeader
                childClass="aboutBGSection"
                breadcrumb={<> About Us</>}
                title="About"
            />
        </>
    )
}